import Customizations from '../components/customizations';

import Swiper, { Manipulation, Lazy, Zoom, Pagination } from 'swiper';
Swiper.use([Manipulation, Lazy, Zoom, Pagination]);

const Product = {
  mainSlider: {
    element: document.querySelector('[data-main-slider]'),
    swiper: false,
  },
  thumbsSlider: {
    element: document.querySelector('[data-slider-thumbs]'),
    swiper: false,
  },
  sectionProduct: document.querySelector('[data-section-product]'),
  imagesWithoutSkus: [],
  thumbsWithoutSkus: [],
  imagesWithSkus: {},
  thumbsWithSkus: {},
  imagesPagination: {
    current: document.querySelector(
      '[data-section-product] .wrapper-slider .pagination [data-pagination-current]'
    ),
    limit: document.querySelector(
      '[data-section-product] .wrapper-slider .pagination [data-pagination-size]'
    ),
  },
  setImages: function () {
    const mainProdId = window.mainProductId;
    const variants = window.productVariants[mainProdId];
    let skus = [];
    if (variants) skus = variants.map((variant) => variant.sku);

    // Armazena os slides de imagens com e sem SKU
    Product.setImagesWithSkus(skus);
    Product.setImagesWithoutSkus();

    // Altera as imagens conforme troca de SKU selecionado
    Product.sectionProduct.addEventListener('vnda:sku-change', (event) => {
      Product.updateImages(event.detail.sku);
    });

    // Exibe as imagens do SKU da primeira variante
    const sku = Product.sectionProduct.querySelector('input[name="sku"]')?.value;
    Product.updateImages(sku);
  },
  setImagesWithoutSkus: function () {
    const thumbsElement = Product.thumbsSlider.element;
    const mainElement = Product.mainSlider.element;

    if (thumbsElement)
      Product.thumbsWithoutSkus = thumbsElement.querySelectorAll('[data-without-sku]');

    if (mainElement) Product.imagesWithoutSkus = mainElement.querySelectorAll('[data-without-sku]');
  },
  setImagesWithSkus: function (skus) {
    const thumbsElement = Product.thumbsSlider.element;
    const mainElement = Product.mainSlider.element;

    // Busca todas as imagens marcadas com SKU
    const images = thumbsElement
      ? [
          ...mainElement.querySelectorAll('[data-with-sku]'),
          ...thumbsElement.querySelectorAll('[data-with-sku]'),
        ]
      : [...mainElement.querySelectorAll('[data-with-sku]')];

    // Separa as imagens dentro por SKU, dentro de Thumbs e Main
    skus.forEach((sku) => {
      Product.imagesWithSkus[sku] = [];
      Product.thumbsWithSkus[sku] = [];

      images.forEach((image) => {
        const imageSkus = image.getAttribute('data-skus');
        let type = 'main';
        if (image.getAttribute('data-image-thumb') != null) type = 'thumb';

        if (imageSkus.includes(sku)) {
          type == 'main'
            ? Product.imagesWithSkus[sku].push(image)
            : Product.thumbsWithSkus[sku].push(image);
        }
      });
    });
  },
  updateImages: function (sku) {
    const main = Product.mainSlider.swiper;
    const skuImages = Product.imagesWithSkus[sku];

    // Adiciona/Remove imagens do swiper principal
    // de acordo com sku selecionado
    main.removeAllSlides();
    main.appendSlide(Product.imagesWithoutSkus);
    if (skuImages) main.appendSlide(skuImages);

    // Atualiza o swiper após a remoção/adição de slides
    main.update();
    main.lazy.load();

    // Muda para o primeiro slide
    main.slideTo(0);
  },
  setGallery: function () {
    const thumbs = document.querySelectorAll('[data-image-thumb]');
    const sliderContainer = document.querySelector('[data-main-slider]');
    const prevButton = sliderContainer.querySelector('.swiper-button-prev');
    const nextButton = sliderContainer.querySelector('.swiper-button-next');

    const mainSlider = new Swiper(Product.mainSlider.element, {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 700,
      simulateTouch: true,
      watchOverflow: true,
      pagination: {
        clickable: true,
        bulletClass: 'bullet',
        bulletActiveClass: '-active',
        el: '.wrapper-slider .pagination',
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
        disabledClass: '-disabled',
      },
      lazy: {
        loadPrevNext: window.mobile ? true : false,
        loadOnTransitionStart: true,
      },
      zoom: {
        maxRatio: 2,
        zoomedSlideClass: '-zoomed',
      },
      on: {
        init: () => {
          Product.mainSlider.element.style.height = `${Product.mainSlider.element.scrollHeight}px`;
        },
        resize: () => {
          Product.mainSlider.element.style.height = `${Product.mainSlider.element.scrollHeight}px`;
        },
        beforeResize: () => {
          Product.mainSlider.element.style.height = 'auto';
        },
        slideChangeTransitionStart: (e) => {
          thumbs.forEach((thumb) => {
            thumb.classList.remove('-active');
          });
          thumbs[e.activeIndex].classList.add('-active');
        },
      },
    });
    mainSlider.on('lazyImageReady', () => {
      mainSlider.update();
    });
    window.addEventListener('load', () => {
      mainSlider.update();
    });
    Product.mainSlider.swiper = mainSlider;

    if (thumbs.length > 0)
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          mainSlider.slideTo(i);
        });
      });
  },
  setZoom: function () {
    const zoom = document.querySelector('[data-zoom]');
    if (zoom) {
      let closes = zoom.querySelectorAll('[data-zoom-close]');
      let images = zoom.querySelectorAll('[data-zoom-image]');
      let slides = document.querySelectorAll('[data-main-slider] .swiper-slide');
      if (closes.length > 0 && images.length > 0 && slides.length > 0) {
        closes.forEach((close) => {
          close.addEventListener('click', () => {
            zoom.classList.remove('-active');

            setTimeout(() => {
              images.forEach((image) => {
                image.classList.remove('-active');
              });
            }, 500);
          });
        });

        slides.forEach((slide, i) => {
          slide.addEventListener('click', () => {
            zoom.classList.add('-active');
            images[i].classList.add('-active');
          });
        });
      }
    }
  },
  setDescription: function () {
    const expand = document.querySelector('[data-description-expand]');
    if (expand)
      expand.addEventListener('click', () => {
        expand.parentElement.classList.add('-active');
      });
  },
  setDownload: function () {
    const button = document.querySelector('[data-download]');
    if (button)
      button.addEventListener('click', () => {
        let xhr = new XMLHttpRequest();
        let url = button.getAttribute('data-download');
        let filename = button.getAttribute('data-name');

        xhr.responseType = 'blob';
        xhr.onload = function () {
          let a = document.createElement('a');
          a.href = window.URL.createObjectURL(xhr.response);
          a.download = filename;
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.remove();
        };
        xhr.open('GET', url);
        xhr.send();
      });

    const swiperEl = document.querySelector('[data-download-carousel]');
    if (swiperEl)
      new Swiper(swiperEl, {
        watchOverflow: true,
        speed: 700,
        watchSlidesProgress: true,
        loop: false,
        simulateTouch: true,
        spaceBetween: 16,
        slidesPerView: 1,
        breakpoints: {
          768: {
            spaceBetween: 24,
            slidesPerView: 3,
          },
          992: {
            spaceBetween: 40,
            slidesPerView: 3,
          },
        },
        // swiper lazy load
        preloadImages: false,
        watchVisibility: true,
        lazy: {
          loadPrevNext: false,
          loadOnTransitionStart: true,
        },
      });
  },
  setRelated: function(){
    const relacionados = document.querySelector('[data-swiper-relacionados]')
    
    if (!relacionados) return
    
    const next = relacionados.querySelector('.swiper-button-next')
    const prev = relacionados.querySelector('.swiper-button-prev')

    let newSwiper = new Swiper(relacionados, {
      slidesPerView: 2,
      simulateTouch: true,
      watchOverflow: false,
      speed: 700,
      spaceBetween: 32,
      navigation: {
        nextEl: next,
        prevEl: prev,
        disabledClass: '-disabled',
      },
      breakpoints: {
        992: {
          slidesPerView: 4,
        },
      },
    });
  },
  init: function () {
    this.setGallery();
    this.setImages();
    this.setZoom();
    Customizations.init();
    this.setDescription();
    this.setDownload();
    this.setRelated();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Product.init();
});
